export default __webpack_public_path__ + "static/media/jira.e1632991.svg";